import {Feedback_RootState} from "firebase-feedback";
import {setAutoFreeze, setUseProxies} from "immer";
import {configure} from "mobx";
import {Graphlink} from "mobx-graphlink";
import {O, wvc_store} from "web-vcore";
import {GraphDBShape} from "../Server/DBShape.js";
import {MainState} from "./main.js";
import {ignore} from "mobx-sync";

// configure({ enforceActions: 'always' });
configure({enforceActions: "observed"});
// fixes various issues when Immer is sent mobx objects (see NPMPatches.ts for old fix attempts)
setUseProxies(false);
setAutoFreeze(false);

export class RootState {
	// [immerable] = true; // makes the store able to be used in immer's "produce" function

	@O accessor main = new MainState();

	//@O forum: any;
	//@O feedback: Feedback_RootState;
	//@O.ref feedback = new Feedback_RootState(); // needed due to details of how mobx/immer work -- will probably make unneeded later
	@O.ref accessor feedback: Feedback_RootState|n; // O.ref needed due to details of how mobx/immer work -- will probably make unneeded later

	@O @ignore accessor graphlink: Graphlink<RootState, GraphDBShape>;

	// modules
	@O accessor wvc = wvc_store;
	//@O @ignore vMenu: VMenuState;
}

export const store = new RootState();
G({store});